export default "__VITE_ASSET__adf68df9__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg11__"